import { DesignFeature } from '../../../../types/catalog';
import Carousel from './carousel';

function FeatureCarousel({ features }: { features: DesignFeature[]; }) {
    return (
        <Carousel
            items={features}
            swiperProps={{
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1280: {
                        slidesPerView: 3,
                    },
                },
            }}
            itemRenderFn={({ url, imageUrl, description }) => (
                <a href={url} className='swiper-slide product-features-item'>
                    <div className='product-features-item-card'>
                        <div
                            className='product-features-item-card__image'
                            style={{ backgroundImage: imageUrl ? `url('${imageUrl}')` : 'none' }}
                        />
                        <div className='product-features-item-card__info'>
                            <p className='product-features-item-card__text'>{description}</p>
                            {/*<p className="product-features-item-card__link">Подробнее</p>*/}
                        </div>
                    </div>
                </a>
            )}
        />
    );
}

export default FeatureCarousel;
